import store from '../../../core/store';

export const listTimesheetReport = () => {
  return store.dispatch({
    action: 'table.timesheet_report/LIST_TIMESHEETS',
    method: 'GET',
    endpoint: '/timesheet_summary_views',
    main: true,
  });
};
